export default "__VITE_ASSET__DmDd8Xjv__"